import React, { useState, useLayoutEffect } from 'react';
import { Link } from 'gatsby';
import { useMenuQuery } from '../../hooks/use-menu-query'
import styled from '@emotion/styled/macro'
import { Theme2 } from "../Layout"
import { Menu, CloseButton, LogoInverted, Call, RightRedArrow, LeftRedArrow } from '../SVGs'
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'
import { Modal } from '../Modal'
import { HomeFormContainer } from '../HomeFormContainer'

const NavigationBar = styled.div`
display: flex;
  justify-content: start;
  align-items: center;
`

const NavContainer = styled.div`
position: absolute;

li{
  margin: 0;
}
ul{
  margin-left: 0;
}
.nav-menu{
  background-color: ${Theme2.colors.dark1};
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: -100%;
  transition: 850ms;
  overflow: auto;
  z-index: 3;
}

  .nav-text {
  display: grid;
  grid-template-columns: 90% 10%;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  width: 100%;
  text-transform: uppercase;
  font-size: 15px;
  box-sizing: border-box;
  border-bottom: 1px solid ${Theme2.colors.neutral};
}
.nav-text button{
  appearance: none;
  border: none;
  background-color: transparent;
  height: 100%;
}

.nav-text a {
  text-decoration: none;
  color: ${Theme2.colors.neutral};
  padding: 35px 25px;
  box-sizing: border-box;
}

.nav-text a:hover {
  background-color: ${Theme2.colors.tertiary};
}

.nav-menu-items {
  width: 100%;
}

.navbar-toggle {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: start;
  align-items: center;
  position: relative;
}

.nav-menu.active{
  
  transition: 350ms;
  @keyframes inAnimation {
    100% {
      left: 0;
    }
  }
}


.logoCloseContainer{
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
}
.mobileMenuButtonsContainer{
  display: grid;
  justify-content: center;
  grid-row-gap: 20px;
  margin-top: 50px;
}
.phoneButton{
  background-color: ${Theme2.colors.light2};
  color: ${Theme2.colors.dark1};
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 290px;
    padding: 18px 42px;
    box-sizing: border-box;
    font-size: 23px;
    

    svg{
      margin-right: 24px;
    }
}
.freeConsult{
  appearance: none;
  background-color: ${Theme2.colors.tertiary};
  text-transform: uppercase;
  color: ${Theme2.colors.light};
  text-align: center;
  padding: 18px 42px;
  font-size: 16px;
  appearance: none;
  border: none;
  width: 290px;
  margin-bottom: 150px;
  display: inline-block;
  box-sizing: border-box;
}
.secondLevel, .thirdLevel, .fourthLevel{
  grid-column: 1 / span 2;
  border-top: 1px solid ${Theme2.colors.neutral};
}
.secondLevel li{
  background-color: ${Theme2.colors.tertiary};
}
.thirdLevel li{
  background-color: ${Theme2.colors.light2};
}
.thirdLevel a, .fourthLevel a{
  color: ${Theme2.colors.dark1};
}
.fourthLevel li{
  background-color: ${Theme2.colors.neutral};
}
`


function useLockBodyScroll() {
 
  useLayoutEffect(() => {
    // Get Y offset
    const windowOffset = window.scrollY
    
    //Make body stay at that Y offset and disable body scrolling
    document.body.setAttribute('style', `position: fixed; top: -${windowOffset}px; left: 0; right: 0; overflow: hidden;`)

    // Re-enable scrolling when component unmounts
    return () => {
      document.body.setAttribute('style', '')
      window.scrollTo(0, windowOffset)
    };
  }, []); // Empty array ensures effect is only run on mount and unmount
}
function NavModal({ onClose }) {
  
  const [modalOpen, setModalOpen] = useState(false);
  const modalContent = <HomeFormContainer />

  const { commonItemsTopBarTextMobile, commonItemsOffices } = useCommonItemsQuery()
    const tel = "tel:"
    const phoneNumber = commonItemsOffices[0].commonItemsPhone
    const phoneNumberHref = tel+phoneNumber
  
  
  const[isHidden , setIsHidden] = useState({})
  const[isHidden2 , setIsHidden2] = useState({})
  const[isHidden3 , setIsHidden3] = useState({})
  const toggleHidden = (key) => {
    setIsHidden(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
  }
  
  const toggleHidden2 = (key) => {
    setIsHidden2(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
  }
  const toggleHidden3 = (key) => {
    setIsHidden3(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
  }
  const data = useMenuQuery();
  // Call hook to lock body scroll
  useLockBodyScroll();
  const mountedStyle = { animation: "inAnimation 0.5s forwards " };
  return (
    <>
    <NavContainer >
        <nav className="nav-menu active" style={mountedStyle}>
          <ul className='nav-menu-items' >
            <li key="1">
              <ul className="logoCloseContainer">
              <li>
            <Link to='/'>
            <LogoInverted />
            </Link>
            </li>
            <li key="2" className='navbar-toggle' onClick={onClose}>
             
                <CloseButton />
              
            </li>
              </ul>
            </li>
            
            {data.nodes.map(menuItem => {
          return(
                 <li key={menuItem.label} className="nav-text">
                   <Link to={menuItem.path}>{menuItem.label}</Link>
                   {menuItem.childItems.nodes.length &&
                     <button key={menuItem.id} onClick={() =>toggleHidden(menuItem.id)}>{isHidden[menuItem.id] ? <LeftRedArrow /> : <RightRedArrow />}</button>
                   }
                   {isHidden[menuItem.id] ?
                   menuItem.childItems.nodes.length &&
                   <ul className="secondLevel">
                   {menuItem.childItems.nodes.map(secondLevel => {
                     return(
                     <li key={secondLevel.label} className="nav-text">
                       <Link to={secondLevel.path}>{secondLevel.label}</Link>
                       
                       {secondLevel.childItems.nodes.length !==0 &&
                       <>
                       <button key={secondLevel.id} onClick={() =>toggleHidden2(secondLevel.id)}>{isHidden2[secondLevel.id] ? <LeftRedArrow color="#fff" /> : <RightRedArrow color="#fff" />}</button>
                       {isHidden2[secondLevel.id] ?
                       
                         <ul className="thirdLevel">
                           {secondLevel.childItems.nodes.map(thirdLevel =>{
                             return(
                              <li key={thirdLevel.label} className="nav-text">
                              <Link to={thirdLevel.path}>{thirdLevel.label}</Link>
                              
                              {thirdLevel.childItems.nodes.length !==0 &&
                              <>
                              <button key={thirdLevel.id} onClick={() =>toggleHidden3(thirdLevel.id)}>{isHidden3[thirdLevel.id] ? <LeftRedArrow /> : <RightRedArrow />}</button>
                              {isHidden3[thirdLevel.id] ?
                              
                                <ul className="fourthLevel">
                                  {thirdLevel.childItems.nodes.map(fourthLevel =>{
                                    return(
                                    <li key={fourthLevel.label} className="nav-text">
                                      <Link to={fourthLevel.path}>{fourthLevel.label}</Link>
                                    </li>
                                  )
                                  })}
                              
                                </ul> : null
                          }
                                </>
                          }
                            </li>
                           )
                           })}
                       
                         </ul> : null
                   }
                         </>
                   }
                     </li>
                   )
                   })}
                   </ul> : null
        
        }
                   </li>
          )
          
                })}

            <li>
<ul className="mobileMenuButtonsContainer">
<li key="3">
{/* Temporarily commenting out because it does not want to cooperate with Whatconverts
<a href={phoneNumberHref} className="phoneButton">
<Call color={Theme2.colors.dark1} />{phoneNumber}
              </a>*/}
</li>
<li key="4">
  <button onClick={() => setModalOpen(true)} className="freeConsult">
    {commonItemsTopBarTextMobile}
  </button>
</li>
</ul>
            </li>

          </ul>
        </nav>
        </NavContainer>
        <Modal onClose={() => setModalOpen(false)} modalOpen={modalOpen} modalContent={modalContent}  />
        </>
  );
}
function Navbar(modalOpen) {
  const [sidebar, setSidebar] = useState(false);
  
  
  

  return (
    <>
     
        <NavigationBar className='navbar' onClick={() => setSidebar(true)}>
         
            <Menu  />
         
        </NavigationBar>
        {sidebar && (
          
<NavModal  onClose={() => setSidebar(false)} />
         
        
        )}
        
    </>
  );
}

export default Navbar;